import { IBSKTDotHoc } from "../../../model/respone/category/IBSKTDotHoc";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eBSKTDotHocActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IBSKTDotHoc[],
  LOAD_ERRR: "",
};
export const eBSKTDotHocActionIds = generateActionTypeIds(
  eBSKTDotHocActionsObj,
  "BSKT_DOT_HOC",
);
export type IBSKTDotHocActionTypes = IGenericActionType<
  typeof eBSKTDotHocActionsObj,
  "BSKT_DOT_HOC"
>;
